import {
  SERVICE_DETAIL_FETCH,
  SERVICE_DETAIL_SUCCESS,
  SERVICE_DETAIL_FAILURE
} from './actionTypes';

const initialState = {
  isLoaded: false,
  error: []
};

export const serviceDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case SERVICE_DETAIL_FETCH:
      return { ...state, isLoaded: false };
    case SERVICE_DETAIL_SUCCESS:
      return { ...state, isLoaded: true };
    case SERVICE_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/ServiceDetail/reducer.js